module.exports = __webpack_public_path__ + "media/_/_/node_modules/gateway_web_console/app/assets/images/light_theme-ab4a67190ee2b2022837222738899125.png";